import { z } from 'zod';

/** UUID v4 string (client-generated via crypto.randomUUID). */
export const zUuid = z.string().uuid();

/** Business date 'YYYY-MM-DD' — never a Date (ADR-004). */
export const zBusinessDate = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/, 'BusinessDate must be YYYY-MM-DD');

/** Server/client timestamptz as ISO-8601 string. */
export const zTimestamptz = z.string().min(1);

/** ISO currency code. */
export const zCurrency = z.string().length(3);

/**
 * Money as bigint cents. Accepts bigint or integer number on parse
 * (IndexedDB / JSON may surface either) and always outputs bigint.
 */
export const zCents = z
  .union([z.bigint(), z.number().int()])
  .transform((n) => (typeof n === 'bigint' ? n : BigInt(n)));

export const zCentsNull = zCents.nullable();

export const zStringArray = z.array(z.string());
export const zUuidArray = z.array(zUuid);
export const zJson = z.unknown();
